import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useRouteMatch
} from "react-router-dom";
import Sidebar from "../../mainsidebar/sidebar";
import ContentCss from "../content.css";
import Business from "./Business";
import Greeting from "./Greeting";
import Position from "./Position";

const Introduction = () => {
  const match = useRouteMatch();
  const LinkAddress = [
    {
      address: "greeting",
      title: "인사말",
      components: Greeting
    },
    {
      address: "business",
      title: "협회사업",
      components: Business
    },
    {
      address: "position",
      title: "조직도",
      components: Position
    }
  ];
  return (
    <>
      <Router>
        <ContentCss.ContentContainer>
          <ContentCss.ContentSideContainer>
            <div className="SideTitle">
              <p>협회소개</p>
            </div>
            <Sidebar Linkto={LinkAddress} NowAddress={match}></Sidebar>
          </ContentCss.ContentSideContainer>
          <Switch>
            <ContentCss.ContentMainContainer>
              <Route exact path={match.path} component={Greeting}></Route>
              {LinkAddress.map(data => (
                // path={`${match.path}/${data.address}`}
                <Route
                  key={data.address}
                  path={`${match.path}/${data.address}`}
                  component={data.components}
                ></Route>
              ))}
            </ContentCss.ContentMainContainer>
          </Switch>
        </ContentCss.ContentContainer>
      </Router>
    </>
  );
};

export default Introduction;
